import EnactedLawBulletin from './[slug]';

export async function getStaticProps() {
  return {
    props: {
      statecode: 0,
    },
  };
}

export default EnactedLawBulletin;
